import React from 'react';
import {Formik} from 'formik';
import {Trans, useTranslation} from 'react-i18next';
import {FormDatePicker} from '../../../shared/form/form-control/FormDatePicker';
import {Btn} from '../../../shared/elements/btn/Btn';
import {Col} from '../../../shared/grid/grid-features/Col';
import {Row} from '../../../shared/grid/grid-features/Row';
import moment from 'moment';
import {createExportDataSchema, downloadFileFromAxiosResponse} from '../customers/helper';
import {getCustomerDataExport} from '../customers/endpoints';

export default function CustomerDownloadTabView({selectedCustomer}) {
    const [isExporting, setIsExporting] = React.useState(false);
    const {t} = useTranslation();

    const initialValues = {
        timestampFrom: moment().add(-1, 'months').startOf('month'),
        timestampTo: moment().add(-1, 'months').endOf('month').startOf('day'),
    };

    /**
     * Requests the data export from the backend and downloads the file.
     * @param {typeof initialValues} values The form values.
     */
    const exportData = (values) => {
        setIsExporting(true);
        getCustomerDataExport(
            values.timestampFrom.format('YYYY-MM-DD'),
            values.timestampTo.format('YYYY-MM-DD'),
            selectedCustomer.customerId,
        )
            .then(downloadFileFromAxiosResponse)
            .finally(() => {
                setIsExporting(false);
            });
    };

    return (
        <div>
            <h2>Export</h2>

            <p>
                <Trans i18nKey="warehousing.downloads.export.description" values={{name: selectedCustomer.name}} />
            </p>

            <Formik initialValues={initialValues} validationSchema={createExportDataSchema(t)} validateOnChange>
                {(form) => (
                    <>
                        <Row>
                            <Col colsize="33">
                                <FormDatePicker
                                    label={t('warehousing.downloads.export.fromDate')}
                                    name="timestampFrom"
                                    // FormDatePicker works with Date object instead of moment
                                    selected={form.values.timestampFrom?.toDate()}
                                    onChange={(value) => {
                                        const date = value ? moment(value) : null;
                                        form.setFieldValue('timestampFrom', date);
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('timestampFrom', true);
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    selectsStart
                                    startDate={form.values.timestampFrom?.toDate()}
                                    endDate={form.values.timestampTo?.toDate()}
                                />
                            </Col>
                            <Col colsize="33">
                                <FormDatePicker
                                    label={t('warehousing.downloads.export.toDate')}
                                    name="timestampTo"
                                    // FormDatePicker works with Date object instead of moment
                                    selected={form.values.timestampTo?.toDate()}
                                    onChange={(value) => {
                                        const date = value ? moment(value) : null;
                                        form.setFieldValue('timestampTo', date);
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('timestampTo', true);
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    selectsEnd
                                    startDate={form.values.timestampFrom?.toDate()}
                                    endDate={form.values.timestampTo?.toDate()}
                                />
                            </Col>
                        </Row>

                        <Btn
                            color="primary"
                            disabled={isExporting || form.isValidating || !form.isValid}
                            onClick={() => exportData(form.values)}
                        >
                            {t('warehousing.downloads.export.export')}
                        </Btn>
                    </>
                )}
            </Formik>
        </div>
    );
}
